<template>
  <div class="login-header-kids">
    <router-link
      :to="{ name: '/home' }"
      class="login-header-kids__logos"
    >
      <img
        src="/svg/logo.svg"
        alt="AfterSchoolVote"
        class="login-header-kids__logo"
      />
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.login-header-kids {
  height: 40px;

  &__logos {
    display: flex;
    align-items: center;
    height: 40px;
    min-width: 0;
  }

  &__logo {
    display: block;
    height: 40px;
    width: auto;
  }
}
</style>
